import React from 'react';
import ReactSwitch, { ReactSwitchProps } from 'react-switch';

const Switch: React.FC<ReactSwitchProps> = ({ ...rest }) => {
  return (
    <ReactSwitch
      checkedIcon={false}
      uncheckedIcon={false}
      onColor="#329bfc"
      height={16}
      width={35}
      handleDiameter={10}
      {...rest}
    />
  );
};

export default Switch;
